
var module = angular.module('AngularAdmin');

module.factory('OrderPlannerSvc', require('./OrderPlannerSvc.js'));
module.factory('Strings', require('./StringsSvc.js'));
module.factory('InvitationSvc', require('./InvitationSvc.js'));
module.factory('UrlWatcherService', require('./UrlWatcherService.js'));
module.factory('UserProfileSvc', require('./UserProfileSvc.js'));
module.factory('OrderRequestSvc', require('./OrderRequestSvc.js'));
module.factory('CalendarNoteSvc', require('./CalendarNoteSvc.js'));
require('./ForecastSvc.js');
require('./MaterialService.js');
require('./MembershipSvc.js');
require('./MixDesignSvc.js');
require('./ModalSvc.js');
require('./OrderSvc.js');
require('./PermissionSvc.js');
require('./PlantSvc.js');
require('./ProductionModeSvc.js');
require('./ProductionScheduleSvc.js');
require('./SupplierSvc.js');
